// CSS Loading
import '../node_modules/jquery-confirm/dist/jquery-confirm.min.css'
import '../node_modules/gentelella/vendors/bootstrap/dist/css/bootstrap.css'
import '../node_modules/gentelella/vendors/bootstrap/dist/css/bootstrap-theme.css'
import '../node_modules/gentelella/vendors/font-awesome/css/font-awesome.css'
import '../node_modules/gentelella/vendors/mjolnic-bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css'
import '../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.css'
import '../node_modules/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css'
import '../node_modules/summernote/dist/summernote.css'
import '../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput.css'
import '../node_modules/bootstrap-tagsinput/dist/bootstrap-tagsinput-typeahead.css'
import '../node_modules/gentelella/build/css/custom.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// ieだとPromiseが動作しない
import 'babel-polyfill'
import 'jquery'
import 'jquery-sidebar'
import 'jquery-confirm'
import 'bootstrap'
import 'mjolnic-bootstrap-colorpicker'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker-ja'
import 'underscore'
import 'bootstrap-switch'
import 'summernote'
import 'clipboard'
import 'bootstrap-tagsinput'
import 'bootstrap-3-typeahead'
import 'gentelella'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'

import VueStash from 'vue-stash'
Vue.use(VueStash)
import { UserStore } from '@/store'

Vue.config.productionTip = false

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

/* eslint-disable no-new */
// アプリケーションを稼働する(index.htmlの<div id="app"></div>がターゲット)
// routerを設定、componetnsにApp.vueをバインドする
new Vue({
  el: '#app',
  router,
  template: '<App></App>',
  components: { App },
  data: {
    store: {
      user: UserStore
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js